<template>
    <v-app-bar
        :color="isProduction ? 'primary' : 'error'"
        class="shrink">
        <v-app-bar-nav-icon
            color="white"
            @click.native.stop="toggleDrawer()"/>
        <v-toolbar-title class="text-xs-center">
          <span class="hidden-md-and-down">
            <span class="white--text">{{ _.get($route, 'meta.title', '???') }}</span>
          </span>
          <span class="white--text font-weight-bold text-center" v-if="!isProduction">
              {{ 'APLICATIE DE TEST' }}
          </span>
        </v-toolbar-title>
        <v-spacer/>
        <!-- center logo -->
        <img
            :src="$t('app.assets.logo')"
            class="hidden-md-and-up">
        <v-spacer/>
        <v-menu
            v-if="getAvailableWorkstations.length > 1"
            bottom
            left
            offset-y
            transition="slide-y-transition">
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    dark
                    icon>
                    <v-badge
                        color="error"
                        overlap>
                        <template slot="badge">{{ getAvailableWorkstations.length }}</template>
                        <v-icon color="white">mdi-database</v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <v-card>
                <v-list dense>
                    <v-list-item v-for="(workstation, index) in getAvailableWorkstations"
                                 :key="index"
                                 :color="workstation.id === getWorkstation.id ? 'primary' : undefined"
                                 :disabled="workstation.id === getWorkstation.id"
                                 @click="triggerChangeWorkstation(workstation)"
                    >
                        <v-list-item-title>
                            {{ workstation.name }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
        <v-btn
            dark
            icon
            @click="$router.push({name: 'auth-logout'})">
            <v-icon>power_settings_new</v-icon>
        </v-btn>
        <v-btn
            dark
            icon
            @click="refresh">
            <v-icon>refresh</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    const authMapState = createNamespacedHelpers("auth").mapState;
    const companyMapGetters = createNamespacedHelpers("workstation").mapGetters;
    const companyMapMutations = createNamespacedHelpers("workstation").mapMutations;
    export default {
        computed: {
            ...authMapState({
                isAuthenticated: "isAuthenticated"
            }),
            ...companyMapGetters({
                getAvailableWorkstations: "getAvailableWorkstations",
                getWorkstation: "getWorkstation"
            }),
            isProduction() {
                return this.App.env === 'production'
            }
        },
        methods: {
            ...companyMapMutations({
                changeWorkstation: 'changeWorkstation'
            }),
            toggleDrawer() {
                Bus.$emit("toggleDrawer");
            },
            async refresh() {

                await axios.post(route("api.@cl"))
                try {
                    window.localStorage.removeItem('app')
                }catch(e){}
                await this.$store.dispatch("auth/fetchMe")
                window.location.reload();
            },
            async triggerChangeWorkstation(workstation) {
                await this.changeWorkstation(workstation)
                window.location.reload()
            }
        }
    };
</script>

<style>
</style>
